var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "url(#paint0_linear_3_12340)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6601 10.1011C27.8308 10.2718 27.9267 10.5032 27.9267 10.7446C27.9267 10.9859 27.8308 11.2174 27.6601 11.3881L19.0095 20.0351C18.8388 20.2057 18.6072 20.3016 18.3657 20.3016C18.1243 20.3016 17.8927 20.2057 17.722 20.0351L13.8128 16.1276L7.62717 22.3106C7.45543 22.4764 7.22541 22.5682 6.98666 22.5661C6.74791 22.564 6.51952 22.4683 6.35069 22.2995C6.18186 22.1308 6.08609 21.9025 6.08402 21.6638C6.08194 21.4252 6.17373 21.1953 6.3396 21.0236L13.169 14.197C13.3398 14.0264 13.5713 13.9305 13.8128 13.9305C14.0543 13.9305 14.2858 14.0264 14.4566 14.197L18.3657 18.1045L26.3725 10.1011C26.5433 9.93042 26.7749 9.83456 27.0163 9.83456C27.2578 9.83456 27.4894 9.93042 27.6601 10.1011Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6422 10.7442C20.6422 10.5028 20.7382 10.2713 20.909 10.1006C21.0797 9.92988 21.3113 9.83398 21.5528 9.83398L27.0163 9.83456C27.2578 9.83456 27.4894 9.93042 27.6601 10.1011C27.8308 10.2718 27.9267 10.5032 27.9267 10.7446L27.927 16.2055C27.927 16.4469 27.831 16.6784 27.6603 16.8491C27.4895 17.0198 27.2579 17.1157 27.0164 17.1157C26.7749 17.1157 26.5433 17.0198 26.3725 16.8491C26.2017 16.6784 26.1058 16.4469 26.1058 16.2055V11.6544H21.5528C21.3113 11.6544 21.0797 11.5585 20.909 11.3878C20.7382 11.2171 20.6422 10.9856 20.6422 10.7442Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_12340",
    x1: 16.3083,
    y1: -13.0216,
    x2: 19.3464,
    y2: 119.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedArrow);
export default __webpack_public_path__ + "static/media/locked_arrow.867b110899695ad0605945e31400e1e4.svg";
export { ForwardRef as ReactComponent };